import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { NotificaitonEmailTemplateModel } from './../../../../../misc/workflow/models/notification-email-template.model';
import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild, Renderer2 } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { Attachment, EmailAddress, EmailAttachment, EmailAudit, EmailThread } from "../../../model/models";
import { Type } from '../Integration/model/type';
import { AutoComplete } from "primeng/autocomplete";
import { Status } from 'src/app/models/statusEnums';
import { MessageService } from "primeng/api";
import { AppMainService } from 'src/app/app-main.service';
import { uploadFiles, validateFiles } from '../../../upload-files' //"../.../../upload-files";
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { EmailGenerationNS } from '../model/ml.EmailGeneration';
import { EmailService } from 'src/app/modules/shared/components/shared-emails/email.service';
import { EmailTemplateService } from 'src/app/configurations/system/services/email-template.service';
import { checkValidEmail } from '../../../helpers/check-valid-email.helper';
import { EDITOR_COLORS } from '../../../constants/user-preference.constant';
import Quill from 'quill';
import QuillBetterTablePlus from 'quill-better-table-plus';
import { DomManipulationService } from '../../../services/dom-manipulation.service';
import { customFieldTagRegex } from '../../../constants/custom-field-tag.regex';
import { ParseHelper } from '../../../parse.helper';
import { FormControlList, FormControlListIds } from '../../../constants/formcontrol-list.constants';
import { SharedTemplateService } from '../../../services/template.service';
import { checkValidTagsInText } from '../../../validators/field-tags.validator';
import { NotificationTemplateAttachments } from '../../../../../configurations/system/models/notification-email-template.model';
import { environment } from 'src/environments/environment';
Quill.register({
  'modules/better-table-plus': QuillBetterTablePlus
}, true);

@Component({
  selector: 'app-lion-email-compose-form',
  templateUrl: './email-compose-form.component.html',
  styleUrls: ['./email-compose-form.component.scss'],
  providers: [
  ]
})
export class LionEmailComposeFormComponent implements OnInit, OnChanges {

  @Input() emailAudit: EmailAudit;
  @Input() emailThread: EmailThread = null;
  @Input() action: string;
  @Input() flag: string = '';
  @Input() contacts;
  @Input() channelId: number;
  @Input() objectTypeId: number;
  @Input() objectId: number;
  @ViewChild('editor') editor: any;
  @ViewChild('email') emailForm: FormGroupDirective;
  emailGenerationForm: FormGroup = new FormGroup({});
  // formErrorHandler: FormErrorHandler = new FormErrorHandler();
  toRecipients: EmailAddress[] = [];
  ccRecipients: EmailAddress[] = [];
  bccRecipients: EmailAddress[] = [];
  allRecipients: EmailAddress[] = [];
  allRecipientsDefaults: EmailAddress[] = [];
  validEmailCheck: boolean

  //for emailListDropdown
  emailList: EmailAddress[] = [];
  emailListCopy: EmailAddress[] = [];


  temps = [
    { name: 'Select E-mail Template', code: 'select email template' }
  ]
  selectedTemp = { name: 'Select E-mail Template', code: 'select email template' }
  recipients: EmailAddress[] = [];
  selectedOption = { name: 'Send now', code: 'sendnow' };
  options = [
    { name: 'Send now', code: 'sendnow' },
    { name: 'Save as draft', code: 'draft' },
    { name: 'Schedule', code: 'schedule' }
  ]
  scheduledDate: Date = new Date();
  minimumDate: Date = new Date();
  showCc = false;
  showBcc = false;
  emailRecipTypes: Type[] = [];
  senderName = "";
  items = [];
  @ViewChild('toAutocomplete') toAutocomplete: AutoComplete;
  @ViewChild('ccAutocomplete') ccAutocomplete: AutoComplete;
  @ViewChild('bccAutocomplete') bccAutocomplete: AutoComplete;
  emailAttachments: EmailAttachment[] = [];
  emailTemplateAttachments: any[] = [];
  allowedExtensions = ['.pdf', '.csv', '.txt', '.xlsx', '.xls', '.docx', '.doc', '.png', '.jpg', '.jpeg', '.ppt', '.pptx', '.gif', '.zip']; // For the attachment files
  visible: boolean = false;

  tone: EmailGenerationNS.Tone[] = EmailGenerationNS.GenerateEmailTones;
  emailGenerationScenario: EmailGenerationNS.EmailGenerationScenarioModel = EmailGenerationNS.EmailGenerationScenario;
  isLoadingEmailGenerationScenario: boolean = false;
  emailGenerationScenarioResponse: EmailGenerationNS.EmailGenerationScenarioResponse = { subject: '', body: '' };
  emailGenerationTypes = EmailGenerationNS.EmailGenerationTypes;

  editorModules = {};

  //Email Templates
  emailTemplateList: NotificaitonEmailTemplateModel[] = [];
  selectedEmailTemplate: NotificaitonEmailTemplateModel = null;

  //Fields List
  fieldTypes: SavedSearchNS.IField[] = [];
  fieldTypesByGroup: any[] = [];
  availableFields: SavedSearchNS.IField[] = [];
  currentColList: any[] = [];
  hiddenFields: string[] = ['phone', 'contactEmail', 'social'];
  addedFieldTags: string[] = [];
  selectedType: any = null;
  selectedInsertField: string = "";
  defaultAIImage = `${environment.assestsBasePath}layout/images/ai-icon.png`;

  constructor(
    public app: AppMainComponent,
    private messageService: MessageService,
    private appMainService: AppMainService,
    private emailService: EmailService,
    private emailTemplateService: EmailTemplateService,
    private renderer: Renderer2,
    private domManipulationService: DomManipulationService,
    private sharedTemplateService: SharedTemplateService
  ) {
    this.initGenerateEmailForm();
  }

  ngOnInit(): void {
    //  this.emailListDropdown();
    this.senderName = this.app.configuredUser ? this.app.configuredUser.userMailId : "";
    this.items = [
      {
        label: 'Upload File',
        icon: 'pi pi-fw pi-upload',
        command: () => {
          let elem = document.getElementById('file-upload') as HTMLInputElement;
          elem.click();
        }
      }
    ];
    this.emailGenerationScenario.scenario = '';
    this.emailGenerationScenario.signature = this.app?.user?.userName ?? '';
    this.initEditorModules();
    this.getAllEmailTemplates();
    this.emailList = [];
    this.emailListCopy = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.emailList = [];
    this.emailListCopy = [];
    for (let property in changes) {
      if (property === 'emailThread') {
        this.checkEmailRecipients(this.flag);

        if (this.flag === 'F') {
          this.emailAttachments = this.emailAudit.emailThreads.filter(el => el.id === this.emailThread.id)[0].emailAttachments;
        }
        else if (this.flag == 'A') {
        }
      }
      // called when form opened
      if (changes.contacts && changes.contacts.currentValue) {
        for (const iterator of changes.contacts.currentValue) {
          this.contacts = iterator;
          this.setAllRecipients(this.contacts.contactEmails);
        }
      }

      //when open from draft
      if (changes.emailAudit && changes.emailAudit.currentValue && changes.emailAudit.currentValue.id !== 0 && this.flag === '') {
        if (this.emailAudit?.emailThreads?.filter(el => el.id > 0)[0]?.emailAttachments) {
          this.emailAttachments = this.emailAudit?.emailThreads?.filter(el => el.id > 0)[0]?.emailAttachments;
        }
        const recipients = changes.emailAudit.currentValue.emailThreads[0].emailRecipients;
        this.toRecipients = [];
        this.ccRecipients = [];
        this.bccRecipients = []
        this.allRecipients = [];
        const savedRecepients = [];
        recipients.map(contactEmail => {
          if (contactEmail.emailAddress) {
            savedRecepients.push({
              id: contactEmail.id,
              emailAddress: contactEmail.emailAddress,
              name: contactEmail.name
            })
          }
        });
        const toRecipientType = [];
        const ccRecipientType = [];
        const bccRecipientType = [];
        recipients.map(mailId => {
          if (mailId.type.name == 'To') {
            toRecipientType.push({
              id: mailId.id,
              emailAddress: mailId.emailAddress,
              name: mailId.name
            })
            this.toRecipients = [...toRecipientType];
          } else if (mailId.type.name === 'CC') {
            ccRecipientType.push({
              id: mailId.id,
              emailAddress: mailId.emailAddress,
              name: mailId.name
            })
            this.onClickShowCc();
            this.ccRecipients = [...ccRecipientType];

          } else {
            if (mailId.type.name == 'BCC') {
              bccRecipientType.push({
                id: mailId.id,
                emailAddress: mailId.emailAddress,
                name: mailId.name
              })
              this.onClickShowBcc();
              this.bccRecipients = [...bccRecipientType];

            }
          }


        })
        this.allRecipients = [...savedRecepients];
        // this.toRecipients = [...savedRecepients];

        ////console.log('this.allRecipients draf', this.allRecipients)
      }
    }

    if (changes.emailAudit && changes.emailAudit.currentValue) {
      if (this.emailAudit?.emailThreads && this.emailAudit?.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData) {
        this.loadContentInEditor(this.emailAudit?.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData);
      }
    }
  }


  setAllRecipients(contactEmails) {
    this.allRecipients = [];
    contactEmails.map(contactEmail => {
      this.allRecipients.push({
        id: contactEmail?.id,
        emailAddress: contactEmail.email.emailAddress,
        name: contactEmail.email.emailAddress
      })
    });
    this.allRecipientsDefaults = [... this.allRecipients];

  }

  uploadAttachment(fileInput) {
    this.appMainService.isShowSpinner('upload');
    if (typeof Worker !== undefined) {
      for (let file of fileInput.files) {
        let errors = validateFiles(file, 4, this.allowedExtensions);
        if (errors.length > 0) {
          for (let error of errors) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
          }
          this.appMainService.isHideSpinner('upload');
        } else {
          uploadFiles(file, ({ name, content, size, extension }) => {
            let emailAttachment: EmailAttachment;
            let attachment: Attachment;
            attachment = {
              id: 0,
              content,
              name,
              extension,
              isValid: true,
              sizeInBytes: size,
              statusId: Status.Active,
              createdBy: this.app.user.userId,
              createdDate: new Date(),
              createdSource: this.app.userIP
            }
            emailAttachment = {
              id: 0,
              emailThreadId: this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].id,
              attachment,
              attachmentId: 0,
              createdBy: this.app.user.userId,
              createdDate: new Date(),
              createdSource: this.app.userIP
            }
            this.emailAttachments.push(this.app.copyObjectWithoutRefrence(emailAttachment));
            this.appMainService.isHideSpinner('upload');
          })
        }
      }
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
    }
  }

  addItem(option: any, autoCompleteComponent: AutoComplete) {
    if (autoCompleteComponent.multiInputEl) {
      autoCompleteComponent.multiInputEl.nativeElement.value = '';
    }
    autoCompleteComponent.value = autoCompleteComponent.value || [];
    if (!autoCompleteComponent.isSelected(option)) {
      autoCompleteComponent.value = [...autoCompleteComponent.value, option];
      autoCompleteComponent.onModelChange(autoCompleteComponent.value);
    }

    autoCompleteComponent.onSelect.emit(option);
    if (autoCompleteComponent.multiInputEl) {
      autoCompleteComponent.multiInputEl.nativeElement.focus();

    }
  }

  checkEmailRecipients(flag) {
    this.toRecipients = [];
    this.ccRecipients = [];
    this.bccRecipients = [];
    this.getEmailRecipsFlagWise(this.flag);
  }

  getEmailRecipsFlagWise(flag: string) {
    let obj: EmailAddress;
    //console.log(this.emailThread.emailRecipients);

    const sender = this.emailThread.emailRecipients.find(recip => this.app.emailRecipTypes.filter(elem => elem.id === recip.typeId)[0]?.name == 'Sender');
    const recipients = this.emailThread.emailRecipients.filter(recip => this.app.emailRecipTypes.filter(elem => elem.id === recip.typeId)[0]?.name == 'To');

    for (let recip of this.emailThread.emailRecipients) {
      let recipType = this.app.emailRecipTypes.filter(elem => elem.id === recip.typeId)[0].name;

      if (recipType === "Sender" && flag == 'S' && (recip.emailAddress != this.app.configuredUser.userMailId || recipients?.length > 1)) {
        obj = {
          id: recip?.id,
          emailAddress: recip.emailAddress,
          name: recip.name === "" ? recip.emailAddress : recip.name
        }
        this.toRecipients.push(obj);
        this.ccRecipients = [];
        this.bccRecipients = [];
      } else if (recipType === "Sender" && flag !== 'F' && recip.emailAddress != this.app.configuredUser.userMailId) {
        obj = {
          id: recip?.id,
          emailAddress: recip.emailAddress,
          name: recip.name === "" ? recip.emailAddress : recip.name
        }
        this.toRecipients.push(obj);
      }
      else {
        switch (flag) {
          case 'S':
            if (recipType === "To" && recipients?.length == 1 && recip.emailAddress != this.app.configuredUser.userMailId && sender.emailAddress == this.app.configuredUser.userMailId) {
              obj = {
                id: recip?.id,
                emailAddress: recip.emailAddress,
                name: recip.name === "" ? recip.emailAddress : recip.name
              }
              this.toRecipients.push(obj);
              this.ccRecipients = [];
              this.bccRecipients = [];
            }
            break;
          case 'A':
            if ((recipType === "Sender" || recipType === "To") && (recip.emailAddress.toLowerCase() !== this.app.configuredUser.userMailId.toLowerCase())) {
              obj = {
                id: recip?.id,
                emailAddress: recip.emailAddress,
                name: recip.name !== "" ? recip.name : recip.emailAddress
              }
              this.toRecipients.push(obj);
            } else if (recipType === "CC" && recip.emailAddress != this.app.configuredUser.userMailId) {
              this.onClickShowCc()
              obj = {
                id: recip?.id,
                emailAddress: recip.emailAddress,
                name: recip.name === "" ? recip.emailAddress : recip.name
              }
              this.ccRecipients.push(obj);
            } else if (recipType === "BCC" && recip.emailAddress != this.app.configuredUser.userMailId) {
              this.onClickShowBcc();
              obj = {
                id: recip?.id,
                emailAddress: recip.emailAddress,
                name: recip.name === "" ? recip.emailAddress : recip.name
              }
              this.bccRecipients.push(obj);
            }
            break;
          case 'F':
            this.toRecipients = [];
            this.ccRecipients = [];
            this.bccRecipients = [];
            break;
          default:
            this.toRecipients = [];
            this.ccRecipients = [];
            this.bccRecipients = [];
        }
      }
    }
  }

  onKeyUp(event: KeyboardEvent, recipType) {

    if (event.key == "Enter" || event.key == "Tab") {
      let tokenInput = event.srcElement as any;
      if (tokenInput.value) {
        let obj: EmailAddress = this.allRecipients.filter(r => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
        this.validEmailCheck = checkValidEmail(tokenInput.value);
        if (!obj && this.validEmailCheck) {
          obj = {
            id: 0,
            name: tokenInput.value,
            emailAddress: tokenInput.value,
          }
        }
        if (recipType === "to" && obj) {
          this.toRecipients.push(obj);
        } else if (recipType === "tocc" && obj) {
          this.ccRecipients.push(obj);
        } else if (recipType === "bcc" && obj) {
          this.bccRecipients.push(obj);
        }
        let recips = JSON.parse(JSON.stringify(this.allRecipients));
        obj && recips.push(obj);
        this.allRecipients = recips;
        tokenInput.value = "";
      }
    }
  }

  onBlur(event: KeyboardEvent, recipType) {
    let tokenInput = event.srcElement as any;
    if (tokenInput.value) {
      let obj: EmailAddress = this.allRecipients.filter(r => r.name.toLowerCase().startsWith(tokenInput.value.toLowerCase()))[0];
      this.validEmailCheck = checkValidEmail(tokenInput.value);
      if (!obj && this.validEmailCheck) {
        obj = {
          id: 0,
          name: tokenInput.value,
          emailAddress: tokenInput.value
        }
      }
      if (recipType === "to" && obj) {
        this.toRecipients.push(obj);
      } else if (recipType === "tocc" && obj) {
        this.ccRecipients.push(obj);
      } else if (recipType === "bcc" && obj) {
        this.bccRecipients.push(obj);
      }
      let recips = JSON.parse(JSON.stringify(this.allRecipients));
      obj && recips.push(obj);
      this.allRecipients = recips;
      tokenInput.value = "";
    }
  }
  onSelect(event: KeyboardEvent, recipType) {
    if (recipType === "to") {
      this.toRecipients = [...new Map(this.toRecipients.map(item => [item['emailAddress'], item])).values()];
    } else if (recipType === "tocc") {
      this.ccRecipients = [...new Map(this.ccRecipients.map(item => [item['emailAddress'], item])).values()];
    } else if (recipType === "bcc") {
      this.bccRecipients = [...new Map(this.bccRecipients.map(item => [item['emailAddress'], item])).values()];
    }
  }

  onToKeyDown(event: KeyboardEvent, recipType?: string): void {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  onInsideClick(autoCompleteComponent: any): void {
    // console.log(autoCompleteComponent);
    // autoCompleteComponent.show();
    // autoCompleteComponent?.inputClick && autoCompleteComponent?.handleDropdownClick();
  }

  initGenerateEmailForm() {
    this.emailGenerationForm = new FormGroup({
      scenario: new FormControl(null, [Validators.required]),
      tone: new FormControl(EmailGenerationNS.GenerateEmailTones.find(x => x.name == 'Professional'), [Validators.required])
    });
  }

  emailListDropdown(query: any) {
    console.log(this.objectId);
    if (this.emailListCopy?.length > 0) {
      this.emailList = this.emailListCopy.filter((c) => {
        if (!query?.trim()) {
          return true;
        }
        return c.name?.toLowerCase().startsWith(query.toLowerCase());
      });
    }
    else {
      this.emailService.getEmailListDropdown(this.objectTypeId, this.objectId).subscribe((response: any) => {
        this.emailList = response?.map(x => ({
          id: x?.id ?? 0,
          name: x?.name || x.emailId,
          emailAddress: x.emailId
        })) ?? [];
        this.emailListCopy = [...this.emailList];
        if (this.emailList.length) {
          this.emailList = this.emailListCopy.filter((c) => {
            if (!query?.trim()) {
              return true;
            }
            return c.name?.toLowerCase().startsWith(query.toLowerCase());
          });
        }
      })
    }
  }

  getGenerateEmail(tone: EmailGenerationNS.Tone = null, scenario: string = null): void {
    if (this.emailGenerationForm.invalid) {
      // this.formErrorHandler.showErrorOnSubmit();
      this.scrollToError();
      return; //Return if form invalid
    }
    this.isLoadingEmailGenerationScenario = true;
    this.emailGenerationScenario.recipients = this.toRecipients?.map(x => x.name) ?? [];
    const emailGenerationScenarioReq: EmailGenerationNS.EmailGenerationScenarioRequest = {
      maxLength: this.emailGenerationScenario.maxLength,
      signature: this.emailGenerationScenario.signature,
      recipients: this.emailGenerationScenario.recipients,
      tone: tone ? tone.name : this.emailGenerationScenario.tone.name,
      scenario: scenario ?? this.emailGenerationScenario.scenario,
    }
    if (this.emailGenerationScenario.generationType == EmailGenerationNS.EmailGenerationTypes.GenerateEmail) {
      this.emailService.getGenerateEmail(emailGenerationScenarioReq).subscribe((res: any) => {
        this.isLoadingEmailGenerationScenario = false;
        this.emailGenerationScenarioResponse = res;
        this.emailGenerationScenarioResponse.body = this.emailGenerationScenarioResponse?.body?.replace(/\n/gi, "<br>") ?? "";
        this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData = this.emailGenerationScenarioResponse.body ?? '';
        this.emailAudit.subject = this.emailGenerationScenarioResponse.subject ?? '';
        this.loadContentInEditor(this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData);
        this.resetGenerateEmailForm();
      });
    }
    else if (this.emailGenerationScenario.generationType == EmailGenerationNS.EmailGenerationTypes.GenerateReply) {
      this.emailService.getGenerateReply(emailGenerationScenarioReq).subscribe((res: any) => {
        this.isLoadingEmailGenerationScenario = false;
        this.emailGenerationScenarioResponse = res;
        this.emailGenerationScenarioResponse.body = this.emailGenerationScenarioResponse?.body?.replace(/\n/gi, "<br>") ?? "";
        this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData = (this.emailGenerationScenarioResponse.body ?? '') + '<br/><br/><br/>' + (this.emailThread?.messageData ?? '');
        this.loadContentInEditor(this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData);
        this.resetGenerateEmailForm();
      });
    }
    else if (this.emailGenerationScenario.generationType == EmailGenerationNS.EmailGenerationTypes.GenerateFollowup) {
      this.emailService.getGenerateFollowup(emailGenerationScenarioReq).subscribe((res: any) => {
        this.isLoadingEmailGenerationScenario = false;
        this.emailGenerationScenarioResponse = res;
        this.emailGenerationScenarioResponse.body = this.emailGenerationScenarioResponse?.body?.replace(/\n/gi, "<br>") ?? "";
        this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData = (this.emailGenerationScenarioResponse.body ?? '') + '<br/><br/><br/>' + (this.emailThread?.messageData ?? '');
        this.loadContentInEditor(this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData);
        this.resetGenerateEmailForm();
      });
    }
  }

  resetGenerateEmailForm() {
    this.visible = false;
    this.emailGenerationScenario.scenario = '';
    this.initGenerateEmailForm();
  }

  showGenerateEmailDialog(generationType: EmailGenerationNS.EmailGenerationType): void {
    this.emailGenerationScenario.header = EmailGenerationNS.EmailGenerationHeader[generationType];
    this.emailGenerationScenario.scenarioLable = EmailGenerationNS.EmailGenerationScenarioLabel[generationType];
    this.emailGenerationScenario.generationType = generationType;
    if (generationType == EmailGenerationNS.EmailGenerationTypes.GenerateReply || generationType == EmailGenerationNS.EmailGenerationTypes.GenerateFollowup) {
      let emailBody = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData ?? '';
      emailBody = emailBody?.replace(/<br>/gi, "\n") ?? "";
      this.emailGenerationScenario.scenario = emailBody;
    }
    else {
      this.visible = true;
    }
  }

  hideGenerateEmailDialog(): void {
    // this.visible = true;
    this.emailGenerationScenario.scenario = '';
    this.emailGenerationScenario.recipients = [];
    this.isLoadingEmailGenerationScenario = false;
  }

  // Scroll to error handler function
  scrollToError(): void {
    const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
    this.scrollTo(firstElementWithError);

    if (!firstElementWithError) {
      const secondElementWithError = document.querySelector('.p-invalid');
      this.scrollTo(secondElementWithError);
    }
  }

  // Scroll to error element
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  getAllEmailTemplates() {
    if (this.objectTypeId > 0 && this.channelId > 0) {
      this.getLeadAccountTemplateFields();
      this.emailTemplateService.getEmailTemplates(this.objectTypeId, this.channelId, 1).subscribe({
        next: (response) => {
          if (response?.length > 0) {
            this.emailTemplateList = response;
          }
        }
      });
    }
  }

  onClickShowCc(): void {
    this.showCc = !this.showCc;
  }

  onClickShowBcc(): void {
    this.showBcc = !this.showBcc;
  }

  onClickGenerateReplyFollowup(tone: EmailGenerationNS.Tone) {
    // console.log(tone);
    const domparser = new DOMParser();
    const htmlDocument = domparser.parseFromString(this.emailThread?.messageData, 'text/html');
    let bodyText = this.emailThread?.messageData;
    if (htmlDocument) {
      bodyText = htmlDocument?.getElementsByTagName('body')[0]?.innerText ?? this.emailThread?.messageData;
    }
    this.emailGenerationScenario.tone = tone ?? this.emailGenerationScenario.tone;
    this.getGenerateEmail(tone, bodyText);
  }

  //#region Quill Table
  initEditorModules() {
    const backgroundColors: string[] = EDITOR_COLORS;
    this.editorModules = {
      table: false,
      'better-table-plus': {
        operationMenu: {
          items: {
            unmergeCells: {
              text: 'Unmerge cells'
            }
          },
          color: {
            colors: backgroundColors,
            text: 'Background'
          }
        }
      }
    }
  }

  insertTable() {
    let quill = this.editor.getQuill();
    quill.focus();
    const tableModule = quill.getModule('better-table-plus');
    tableModule.insertTable(2, 5)
  }

  loadContentInEditor(messageData: any, updateStyle: boolean = true) {
    if (updateStyle) {
      messageData = this.domManipulationService.replaceDivWithP(messageData);
    }

    setTimeout(() => {
      const _quill = this.editor.getQuill();
      const editorContainer = _quill.root;
      this.renderer.setProperty(editorContainer, 'innerHTML', messageData);
    })
  }
  //#endregion Quill Table End

  //#region email template and field insertion
  selectEmailTemplate($event: any) {
    const selectedEmailTemplate = $event.value;
    if (selectedEmailTemplate) {
      this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData = selectedEmailTemplate.templateBody;
      this.emailAudit.subject = selectedEmailTemplate?.templateSubject ?? '';
      this.getEmailTemplateDetails(selectedEmailTemplate);
    } else {
      this.emailAttachments = [];
      this.emailTemplateAttachments = [];
      this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData = '';
      this.emailAudit.subject = '';
    }

    setTimeout(() => {
      this.selectedType = null;
      this.updatedAddedTags();
    }, 200)
  }

  getEmailTemplateDetails(templateDetails: NotificaitonEmailTemplateModel) {
    this.appMainService.isShowSpinner('getEmailTemplate');
    this.emailTemplateService.getEmailTemplateById(templateDetails.id, templateDetails.statusId).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('getEmailTemplate');
        if (response?.notificationTemplateAttachments?.length > 0) {
          this.emailTemplateAttachments = response?.notificationTemplateAttachments;
          // this.addTemplateAttachments(response?.notificationTemplateAttachments);
        }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getEmailTemplate');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to load ${templateDetails.templateName} Template Information!` });
      }
    })
  }

  addTemplateAttachments(notificationTemplateAttachments: NotificationTemplateAttachments[]) {
    if (notificationTemplateAttachments.length > 0) {
      notificationTemplateAttachments.map(attachmentDetails => {
        let emailAttachment: EmailAttachment;
        let attachment: Attachment;
        attachment = {
          id: attachmentDetails.attachment.id,
          content: "",
          name: attachmentDetails.attachment.name,
          extension: attachmentDetails.attachment.extension,
          isValid: true,
          sizeInBytes: attachmentDetails.attachment.sizeInBytes,
          statusId: Status.Active,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          createdSource: this.app.userIP
        }
        emailAttachment = {
          id: 0,
          emailThreadId: this.emailAudit.emailThreads[this.emailAudit.emailThreads.length - 1].id,
          attachment,
          attachmentId: attachmentDetails.attachment.id,
          createdBy: this.app.user.userId,
          createdDate: new Date(),
          createdSource: this.app.userIP
        }
        this.emailAttachments.push(this.app.copyObjectWithoutRefrence(emailAttachment));
      })
    }

  }

  selectTemplateField($event) {
    const selectedField: any = $event.value;

    if (selectedField?.childGroup || !selectedField) return;

    if (this.selectedInsertField == 'subject') {
      const subjectText = this.emailAudit.subject;
      const insertedText = `${subjectText} [${selectedField.name.trim()}]`;
      this.emailAudit.subject = insertedText;
    } else {
      if (this.editor) {
        const _quill = this.editor.getQuill();

        const selection = _quill.getSelection(true);
        const fieldText: string = ` [${selectedField.name.trim()}] `;
        _quill.insertText(selection?.index || 0, fieldText);
        this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData = _quill.root.innerHTML;
        this.loadContentInEditor(this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData, false);
        const nextCursorPoint = (selection?.index || 0) + (fieldText.length - 1);

        setTimeout(() => {
          _quill.setSelection(nextCursorPoint, 0);
        }, 200)
      }
    }

    setTimeout(() => {
      this.selectedType = null;
      this.updatedAddedTags();
    }, 200)
  }

  updatedAddedTags() {
    this.addedFieldTags = [];
    const messageBody = this.emailAudit.emailThreads[this.emailAudit.emailThreads.length > 1 ? this.emailAudit.emailThreads.length - 1 : 0].messageData;
    const subject = this.emailAudit.subject;
    const value = messageBody + subject;
    if (value) {
      const addedTags: string[] = value.match(customFieldTagRegex) || [];

      addedTags.map(labelName => {
        const exist = this.fieldTypes.find(field => field.name.trim() == labelName.trim());

        if (exist) {
          if (!this.addedFieldTags.includes(exist.name))
            this.addedFieldTags.push(exist.name);
        }
      })
    }

    this.checkValidTags(subject, messageBody);
  }

  emailBodyInvalidTagMsg: string = "";
  emailSubjectInvalidTagMsg: string = "";

  checkValidTags(subject: string, body: string) {
    this.emailBodyInvalidTagMsg = "";
    this.emailSubjectInvalidTagMsg = "";

    if (this.availableFields?.length > 0) {
      const validBodyTags = checkValidTagsInText(this.availableFields, body);
      if (!validBodyTags.valid) {
        this.emailBodyInvalidTagMsg = "Email body have some invalid tags: " + validBodyTags.invalidTags.join(', ');
      }

      const validSubjectTags = checkValidTagsInText(this.availableFields, subject);
      if (!validSubjectTags.valid) {
        this.emailSubjectInvalidTagMsg = "Email subject have some invalid tags: " + validSubjectTags.invalidTags.join(', ');
      }

      return (validBodyTags && validSubjectTags);
    }

    return true;
  }

  getLeadAccountTemplateFields() {
    this.appMainService.isShowSpinner('getColumnSettings');
    this.sharedTemplateService.getTemplateSectionsForFormBuild(this.objectTypeId, this.channelId).subscribe(
      {
        next: (response) => {
          this.currentColList = response || [];
          this.currentColList.map((fields, i) => [
            fields.customFields.map((customFields, i) => {
              const formControlDetails: any = ParseHelper.DeepCopy(customFields.formControl);
              customFields = {
                ...customFields,
                formControl: formControlDetails?.type,
                formControlDetails: formControlDetails,
                isCustom: true
              }

              fields.customFields[i] = customFields;
            })
          ]);
          this.generateLAAvailableFields();
          this.appMainService.isHideSpinner('getColumnSettings');
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getColumnSettings');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message ? error?.error?.Message : 'Column Settings are not loaded, please try again...'
          });
        },
        complete: () => {

        },
      });
  }

  generateLAAvailableFields() {
    this.fieldTypes = [];
    let fieldTypesByGroup = [];

    this.currentColList.map(sectionDetails => {
      const group: any = {
        label: sectionDetails.name,
        value: "",
        items: []
      }
      sectionDetails.fields.map(field => {
        if (field?.childFields?.length > 0) {
          const childGroup: any[] = [];
          field.childFields.map(childField => {
            const fieldDetails = this.setFieldDetails(childField);
            if (fieldDetails) childGroup.push({
              ...fieldDetails,
              label: fieldDetails.name,
              childItem: true
            })
          })

          if (childGroup.length > 0) {
            childGroup.unshift({
              name: field.name,
              value: "",
              childGroup: true
            });

            group.items = [...group.items, ...childGroup]
          }
        } else {
          const fieldDetails = this.setFieldDetails(field);
          if (fieldDetails) group.items.push({
            ...fieldDetails,
            label: fieldDetails.name
          })
        }
      });

      sectionDetails.customFields.map(field => {
        const fieldDetails = this.setFieldDetails(field);
        if (fieldDetails) group.items.push({
          ...fieldDetails,
          label: fieldDetails.name
        })
      });

      fieldTypesByGroup.push(group);
    });
    this.fieldTypesByGroup = ParseHelper.DeepCopy(fieldTypesByGroup);
    this.availableFields = ParseHelper.DeepCopy(this.fieldTypes);

    this.setAvailableFields();
  }

  setFieldDetails(fieldDetails: any) {
    let field = null;
    if (fieldDetails?.field && !this.hiddenFields.includes(fieldDetails.field) && ![FormControlList.FileUpload, FormControlList.Picture].includes(fieldDetails.formControl)) {
      fieldDetails.field = (fieldDetails.field == 'tags') ? 'tagsCsv' : fieldDetails.field;
      field = {
        id: fieldDetails.id,
        labelname: fieldDetails.labelName,
        name: this.getFormatedName(fieldDetails),
        code: fieldDetails.field,
        isrequired: true,
        ischecked: true,
        isShowInSetting: true,
        isDuplicate: true,
        isGlobalSearch: true,
        width: "",
        movable: false,
        showForDrag: false,
        templateId: 0,
        sectionId: 0,
        custom: fieldDetails.isCustom,
        formControlId: FormControlListIds[fieldDetails.formControl],
        formControl: fieldDetails.formControl,
        pickListValues: fieldDetails?.formControlDetails?.pickListValues || [],
        field: fieldDetails.field,
        mapObject: fieldDetails?.mapObject,
        isColumnSetting: true,
        value: "",
        displayOrder: 0,
        fieldTypes: null,
        fieldDataType: "String",
        valueDataType: "String",
        operators: [],
        operatorsDD: []
      }
      this.fieldTypes.push(field);
    }

    return field;
  }

  getFormatedName(fieldDetails: any) {
    let name = fieldDetails.name;

    if (fieldDetails.mapObject == 'leadSocial') {
      name = `Lead ${fieldDetails.name}`
    }

    if (fieldDetails.mapObject == 'accountSocial') {
      name = `Account ${fieldDetails.name}`
    }

    if (fieldDetails.mapObject == 'lead' && fieldDetails.field == 'businessName') {
      name = fieldDetails.labelName
    }

    return name;
  }

  setAvailableFields() {
    if (this.fieldTypesByGroup?.length > 0) {
      this.fieldTypesByGroup.map(group => {
        if (group?.items?.length > 0) {
          const availableItems = group.items.filter(fieldDetails => fieldDetails?.field && fieldDetails?.mapObject != 'opportunityProduct' && ![FormControlList.FileUpload, FormControlList.Picture].includes(fieldDetails.formControl));
          group.items = availableItems;
        }
      })
    }

    this.fieldTypes = [...this.availableFields];
  }


  //#endregion
}
